import { Component, Inject, Input, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PromptDialogModel } from '../../entities/prompt.dialog.model';

@Component({
    selector: 'app-prompt-dialog',
    templateUrl: './prompt-dialog.component.html',
    styleUrls: ['./prompt-dialog.component.scss'],
    standalone: false
})
export class PromptDialogComponent implements OnInit {

    // only input control
    public textInput = new UntypedFormControl("");


    constructor(
        public dialogRef: MatDialogRef<PromptDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: PromptDialogModel,
    ) { }

    ngOnInit(): void {

        // set required validator
        if (this.data.isInputRequired) {
            this.textInput.setValidators([Validators.required]);
            this.textInput.updateValueAndValidity();
        }

    }


    /**
     * Save click event handler
     */
    public async onSaveClick() {

        this.textInput.markAllAsTouched();
        if (this.textInput.valid) {

            // raise on save click event
            const res = await this.data.onSaveClick(this.textInput.value);
            if (res)
                this.dialogRef.close();

        }
    }


    /**
     * Close click event handler
     */
    public async onCloseClick() {
        this.dialogRef.close();
    }

}
